import { render } from "./staff_stamp_image.vue?vue&type=template&id=a61fa8a2"
import script from "./staff_stamp_image.vue?vue&type=script&lang=js"
export * from "./staff_stamp_image.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/staff_stamp_image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a61fa8a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a61fa8a2', __exports__)) {
    api.reload('a61fa8a2', __exports__)
  }
  
  module.hot.accept("./staff_stamp_image.vue?vue&type=template&id=a61fa8a2", () => {
    api.rerender('a61fa8a2', render)
  })

}


export default __exports__